/**
 * ESM shim for shared-components/api/api-env.js
 *
 * shared-components is a submodule (cannot be edited). That file uses CJS
 * require() of public-config.js which is ESM, crashing @rollup/plugin-commonjs.
 * This shim provides the same exports using web-hosting's ESM infrastructure.
 */
import { request as httpRequest } from "../../../../api/http-library.js";
import publicConfig from "../../../../public-config.js";

export const getWebEnv = function (locale, callback) {
  const env_base64 = btoa(publicConfig.env_handshake);
  const request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/web/${locale || "en-US"}`,
    method: "GET",
    headers: { Authorization: "Bearer " + env_base64 },
  };
  httpRequest(request_params, function (response) {
    return callback(response);
  });
};

export const getMetros = (function () {
  var cache = {};
  var maxAge = 300000;
  function find(timeNow, callback) {
    var lastSave = cache.timestamp || 0;
    var timeSpan = timeNow - lastSave;
    find.saveEnv = function (env) {
      cache.metros = env.metros;
      cache.timestamp = timeNow;
      return callback(cache.metros);
    };
    if (lastSave && timeSpan < maxAge) {
      return callback(cache.metros);
    }
    return getWebEnv("", find.saveEnv);
  }
  return find;
})();

export const findMetroByKey = function (keyValObject, callback) {
  getMetros(Date.now(), function (response) {
    var metro =
      response && response.find
        ? response.find(
            (m) =>
              m.name &&
              m.name.toLowerCase() === keyValObject.name.toLowerCase(),
          )
        : undefined;
    var responseObject = {
      match: metro,
      available_metros: response ? response.filter((m) => m.active) : [],
    };
    callback(responseObject);
  });
};

export const getActivities = function (locale, callback) {
  const env_base64 = btoa(publicConfig.env_handshake);
  const request_params = {
    host: publicConfig.external_address,
    path: "/v1/env/keywords/" + locale,
    method: "GET",
    headers: { Authorization: "Bearer " + env_base64 },
  };
  httpRequest(request_params, function (response) {
    return callback(response);
  });
};

export const getTags = function (locale, callback) {
  const env_base64 = btoa(publicConfig.env_handshake);
  const request_params = {
    host: publicConfig.external_address,
    path: "/v1/env/tags/" + locale,
    method: "GET",
    headers: { Authorization: "Bearer " + env_base64 },
  };
  httpRequest(request_params, function (response) {
    return callback(response);
  });
};

export const getEnvLocaleData = async function (locale) {
  const envBase64 = btoa(publicConfig.env_handshake);
  const envRes = await fetch(`/v1/env/web/${locale || "en-US"}`, {
    headers: { Authorization: "Bearer " + envBase64 },
  });
  const envData = await envRes.json();
  return envData;
};

export const getLocaleActivityKeywords = async function (locale) {
  const envBase64 = btoa(publicConfig.env_handshake);
  const responseObj = await fetch(`/v1/env/keywords/${locale || "en-US"}`, {
    headers: { Authorization: "Bearer " + envBase64 },
  });
  const { response } = await responseObj.json();
  return response;
};
